export default {"src":"/_next/static/media/Visa.eaf8e702.svg","height":36,"width":53,"blurWidth":0,"blurHeight":0};